import importerStore from '@shared/importer/importer-store';
import { SiteService } from '@modules/site/site-service';
import siteImporterFields from '@modules/site/site-importer-fields';
import { i18n } from '@shared/i18n';

export default importerStore(
  SiteService.import,
  siteImporterFields,
  i18n('entities.site.importer.fileName'),
  i18n('entities.site.importer.hint'),
);
